import { useMemo } from 'react';
import { css } from '@emotion/css';
import { useTheme } from '@emotion/react';
import { CSSInterpolation } from'@emotion/serialize/types';

export const useClasses = (stylesElement: any) => {
  const theme = useTheme();
  return useMemo(() => {
    const rawClasses = (typeof stylesElement === 'function'
      ? stylesElement(theme)
      : stylesElement) as Array<CSSInterpolation>;
    const prepared = {} as any;

    Object.entries(rawClasses).forEach(([key, value = {}]) => {
      prepared[key] = css(value);
    });

    return prepared;
  }, [stylesElement, theme]);
};

export default useClasses;
